import { useEffect, useState } from 'react';
import { api } from '../services';
import { useLocation } from 'react-router-dom';

export const useServiceCategory = () => {
  const location = useLocation();
  const [isUploadEnabled, setIsUploadEnabled] = useState(false);

  useEffect(() => {
    const checkServiceCategory = async () => {
      try {
        const doctorId = localStorage.getItem('doctor_id');
        console.log('Checking for doctorId:', doctorId);

        if (!doctorId) {
          console.log('No doctorId found, disabling upload');
          setIsUploadEnabled(false);
          return;
        }

        const response = await api.get(
          `Home/GetServiceDoctor?OID=1&doctorId=${doctorId}`,
        );
        let data = response.data;
        console.log('API Response:', data);

        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error('Invalid JSON string:', data);
            setIsUploadEnabled(false);
            return;
          }
        }

        const filteredServices = data.filter((item) => item.OnlineTurning === 1);
        console.log('Filtered Services:', filteredServices);

        if (filteredServices.length === 1) {
          const serviceCategoryID = filteredServices[0].ServiceCategoryID;
          console.log('Found ServiceCategoryID:', serviceCategoryID);
          
          const shouldEnable = serviceCategoryID === 47 || serviceCategoryID === 48;
          console.log('Should enable upload:', shouldEnable);
          
          setIsUploadEnabled(shouldEnable);
        } else {
          console.log('No matching service found, disabling upload');
          setIsUploadEnabled(false);
        }
      } catch (error) {
        console.error('Error in checkServiceCategory:', error);
        setIsUploadEnabled(false);
      }
    };

    if ( location.pathname === '/UploadFiles' || location.pathname === '/PaymentReceipt') {
      checkServiceCategory();
    } else {
      setIsUploadEnabled(false);
    }
  }, [location.pathname]);

  return isUploadEnabled;
};
